import React, { useContext } from 'react';
import { GridOptions } from 'ag-grid-community';
import { useTheme } from '@material-ui/core/styles';
import { LicenseManager } from 'ag-grid-enterprise';
import { AgGridReact } from 'ag-grid-react';
import {
  AgGridTableWrapper,
  Watermark,
  APIAlert,
  Loader,
} from '@mummssoftware/common-ui';
import { Container } from '../../components/layout/WrapperDiv';
import { ReportsContext } from '../Context/ReportsWidgetContext';
import { Context } from '../../context';
import {
  SET_SHOW_LOADER,
  SET_OPEN_REPORT,
  SET_REPORTS_ERROR,
} from '../Context/constants';
import { ReportModal } from '../ReportModal/ReportModal';
import { getColumnDefs, commonColumnDefs } from './tableColumnDefs';

import 'ag-grid-community/dist/styles/ag-grid.css';
import '@mummssoftware/common-ui/style/css/ag-theme-hummingbird.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';

LicenseManager &&
  LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_KEY as string);

interface HopeProps {
  viewModePrint?: boolean;
  smallWidget?: boolean;
}

export const ReportsList = ({ viewModePrint, smallWidget }: HopeProps) => {
  const { onWidgetReady, watermark, patient, reporting } = useContext(Context);
  const { showLoader, dispatch, reportsError, reportList } = useContext(
    ReportsContext,
  );

  const {
    props: { grid: gridTheme },
    palette,
  } = useTheme() as any;

  const [largeListColumnDefs, smallListColumnDefs] = getColumnDefs();

  const onCellClicked = (clickEvent: any) => {
    const {
      colDef: { headerClass },
      data,
    } = clickEvent;
    if (headerClass !== 'button') {
      // dispatch({ type: SET_SHOW_LOADER, payload: true });
      dispatch({ type: SET_OPEN_REPORT, payload: data });
    }
  };

  const columnDefs =
    (smallWidget && largeListColumnDefs) || smallListColumnDefs;

  const gridOptions: GridOptions = {
    detailRowAutoHeight: true,
    embedFullWidthRows: true,
    groupHeaderHeight: 20,
    defaultColDef: {
      ...commonColumnDefs,
    },
    columnDefs,
    onGridReady: (params: any) => {
      onWidgetReady && onWidgetReady('Reports List' as mumms.ComponentName);
    },
  };

  const clearError = () => {
    dispatch({
      type: SET_REPORTS_ERROR,
      payload: null,
    });
  };

  return (
    <Container id="reports-container">
      {showLoader && <Loader />}
      {watermark && watermark.show ? (
        <Watermark
          opacity=".2"
          readOnly={watermark.readOnly}
          smallWidget={smallWidget}
        />
      ) : null}
      {reportsError && (
        <APIAlert
          errorInfo={{ text: reportsError || '', severity: 'error' }}
          handleClose={() => clearError()}
        />
      )}
      <ReportModal />
      <AgGridTableWrapper
        id="reports-list-wrapper"
        className={`${gridTheme.className} light max-width`}
        printMode={viewModePrint}
      >
        <AgGridReact
          gridOptions={gridOptions}
          rowData={(reportList as mumms.ReportDTO[]) || []}
          rowHeight={gridTheme.rowHeight}
          headerHeight={gridTheme.headerHeight}
          onCellClicked={onCellClicked}
          suppressRowClickSelection
          suppressCellSelection
        />
      </AgGridTableWrapper>
    </Container>
  );
};

export default ReportsList;
